import linkChildrenEn from '@/layout/model/notInMenuRouteEn.js';

const linkChildrenGov = [{
    label: '联系人管理',
    attrs: {},
    url: '/system/com/ContactManager',
    linkParent: {
      label: '企业管理',
      url: '/system/com',
    }
  },
  {
    label: '设施管理',
    attrs: {},
    url: '/system/com/DeviceManage',
    linkParent: {
      label: '企业管理',
      url: '/system/com',
    }
  }, {
    label: '设备管理',
    attrs: {},
    url: '/system/org/deviceTree',
    linkParent: {
      label: '组织架构管理',
      url: '/system/org',
    }
  }, {
    label: '分组管理',
    attrs: {},
    url: '/system/org/deviceTree/group',
    linkParent: {
      label: '组织架构管理',
      url: '/system/org',
    }
  }, {
    label: '联系人管理',
    attrs: {},
    url: '/system/org/contact',
    linkParent: {
      label: '组织架构管理',
      url: '/system/org',
    }
  }, {
    label: '配置管理',
    attrs: {},
    url: '/system/org/monitor',
    linkParent: {
      label: '组织架构管理',
      url: '/system/org',
    }
  }, {
    label: '净化器清洗情况查看',
    attrs: {},
    url: '/clean/CleanInfo/details',
    linkParent: {
      label: '清洗情况',
      url: '/clean/CleanInfo',
    }
  }, {
    label: '企业列表',
    attrs: {},
    url: '/dataAnalysis/AnalysisChildrenA',
    linkParent: {
      label: '异常分析',
      url: '/dataAnalysis/AnalysisList',
    }
  }, {
    label: '异常企业列表',
    attrs: {},
    url: '/dataAnalysis/AnalysisChildrenB',
    linkParent: {
      label: '异常分析',
      url: '/dataAnalysis/AnalysisList',
    }
  }, {
    label: '清洗逾期',
    attrs: {},
    url: '/dataAnalysis/AnalysisChildrenC',
    linkParent: {
      label: '异常分析',
      url: '/dataAnalysis/AnalysisList',
    }
  }, {
    label: '设备异常列表',
    attrs: {},
    url: '/dataAnalysis/AnalysisChildrenD',
    linkParent: {
      label: '异常分析',
      url: '/dataAnalysis/AnalysisList',
    }
  }, {
    label: '排放异常列表',
    attrs: {},
    url: '/dataAnalysis/AnalysisChildrenE',
    linkParent: {
      label: '异常分析',
      url: '/dataAnalysis/AnalysisList',
    }
  }, {
    label: '报表查看',
    attrs: {},
    url: '/dataAnalysis/checkReport',
    linkParent: {
      label: '统计报表',
      url: '/dataAnalysis/statisticReport',
    },

  },
  {
    label: '超标企业',
    attrs: {},
    url: '/dashboard/standard',
    linkParent: {
      label: '超标企业',
      url: '/dashboard/index',
    },

  },
  {
    label: '设备异常企业',
    attrs: {},
    url: '/dashboard/equipment',
    linkParent: {
      label: '设备异常',
      url: '/dashboard/index',
    },


  }, {
    label: '油烟浓度告警详情查看',
    attrs: {},
    url: '/alarm/alarmList/concentrationAlarm',
    linkParent: {
      label: '告警列表',
      url: '/alarm/alarmList',
    }
  }, {
    label: '设备离线告警详情查看',
    attrs: {},
    url: '/alarm/alarmList/offlineAlarm',
    linkParent: {
      label: '告警列表',
      url: '/alarm/alarmList',
    }
  }, {
    label: '清洗逾期告警详情查看',
    attrs: {},
    url: '/alarm/alarmList/overdueAlarm',
    linkParent: {
      label: '告警列表',
      url: '/alarm/alarmList',
    }
  }, {
    label: '企业概况',
    attrs: {},
    url: '/dashboard/index/dashboardInfo',
    linkParent: {
      label: '基本概况',
      url: '/dashboard/index',
    }
  }, {
    label: '逾期企业',
    attrs: {},
    url: '/dashboard/index/dashboardClean',
    linkParent: {
      label: '清洗情况',
      url: '/dashboard/index',
    }
  }, {
    label: '一周内待清洗',
    attrs: {},
    url: '/dashboard/index/dashboardNotClean',
    linkParent: {
      label: '清洗情况',
      url: '/dashboard/index',
    }
  }, {
    label: '油烟浓度告警详情查看',
    attrs: {},
    url: '/submit/submitList/concentrationAlarm',
    linkParent: {
      label: '异常列表',
      url: '/submit/submitList',
    }
  }, {
    label: '设备离线告警详情查看',
    attrs: {},
    url: '/submit/submitList/offlineAlarm',
    linkParent: {
      label: '异常列表',
      url: '/submit/submitList',
    }
  }, {
    label: '清洗逾期告警详情查看',
    attrs: {},
    url: '/submit/submitList/overdueAlarm',
    linkParent: {
      label: '异常列表',
      url: '/submit/submitList',
    }
  }
];

let linkChildren = [];

linkChildren.push(...linkChildrenGov);
linkChildren.push(...linkChildrenEn);

export default linkChildren



// WEBPACK FOOTER //
// ./src/layout/model/notInMenuRoute.js